import React from 'react';
import { Spin } from 'antd';

type SessionLoaderProps = {
  message?: string;
};

const SessionLoader: React.FC<SessionLoaderProps> = ({ message }) => {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}
    >
      <Spin size="large" />
      {message && <div style={{ marginTop: 16, fontSize: 16, color: '#555' }}>{message}</div>}
    </div>
  );
};

export default SessionLoader;
